/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Wizard_RefiningInputs */



/**
* | output |
* | --- |
* | "Refining..." |
*
* @param {Agent_Wizard_RefiningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_wizard_refining = /** @type {((inputs?: Agent_Wizard_RefiningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Wizard_RefiningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wird verfeinert...")
	return /** @type {LocalizedString} */ ("Refining...")
});